export default __webpack_public_path__ + "static/media/flag-samoa.a52f8245.svg";